<app-uni-page [parent]="this" pageTitle="In-Process: In-Process" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <app-ag-grid [gridOptions]="johGridOptions" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <p-tabView (onChange)="onTabChanged($event)" class="h-full w-full uni-tabview" styleclass="h-full">
          <p-tabPanel [header]="tabItd.label" class="h-full">
            <app-ag-grid [gridOptions]="itdGridOptions" [rowData]="itemDetails"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel [header]="tabJod.label" class="h-full">
            <app-ag-grid [gridOptions]="jodGridOptions" [rowData]="joDetails"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel [header]="tabPod.label" class="h-full">
            <app-ag-grid [gridOptions]="podGridOptions" [rowData]="poDetails"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel [header]="tabInvoicedItd.label" class="h-full">
            <app-ag-grid [gridOptions]="invoicedItdGridOptions" [rowData]="invoicedItemDetails"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel header="Billing Address">
            <div class="p-4">
              <div class="qb-detail-card qb-primary-tint p-4 max-w-lg">
                <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Bill To</div>
                <div class="qb-stacked-field">
                  <div class="value leading-relaxed text-base">
                    <div>{{ selectedJoHeader?.billingName }}</div>
                    <div>{{ selectedJoHeader?.billingAddress1 }}</div>
                    <div *ngIf="selectedJoHeader?.billingAddress2">{{ selectedJoHeader?.billingAddress2 }}</div>
                    <div *ngIf="selectedJoHeader?.billingAddress3">{{ selectedJoHeader?.billingAddress3 }}</div>
                    <div>{{ selectedJoHeader?.billingCity }}, {{ selectedJoHeader?.billingState }} {{ selectedJoHeader?.billingZipCode }}</div>
                    <div *ngIf="selectedJoHeader?.billingTelephone" class="mt-2">
                      {{ selectedJoHeader?.billingTelephone }}
                      <span *ngIf="selectedJoHeader?.billingExt"> ext. {{ selectedJoHeader?.billingExt }}</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="canEditAddress" class="mt-3 pt-3 border-t">
                  <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-pencil" (click)="editAddress('billing', 'Billing')">
                    <span>Edit Address</span>
                  </button>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Shipping Address">
            <div class="p-4">
              <div class="qb-detail-card qb-primary-tint p-4 max-w-lg">
                <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Ship To</div>
                <div class="qb-stacked-field">
                  <div class="value leading-relaxed text-base">
                    <div>{{ selectedJoHeader?.shippingName }}</div>
                    <div>{{ selectedJoHeader?.shippingAddress1 }}</div>
                    <div *ngIf="selectedJoHeader?.shippingAddress2">{{ selectedJoHeader?.shippingAddress2 }}</div>
                    <div *ngIf="selectedJoHeader?.shippingAddress3">{{ selectedJoHeader?.shippingAddress3 }}</div>
                    <div>{{ selectedJoHeader?.shippingCity }}, {{ selectedJoHeader?.shippingState }} {{ selectedJoHeader?.shippingZipCode }}</div>
                    <div *ngIf="selectedJoHeader?.shippingTelephone" class="mt-2">
                      {{ selectedJoHeader?.shippingTelephone }}
                      <span *ngIf="selectedJoHeader?.shippingExt"> ext. {{ selectedJoHeader?.shippingExt }}</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="canEditAddress" class="mt-3 pt-3 border-t">
                  <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-pencil" (click)="editAddress('shipping', 'Shipping')">
                    <span>Edit Address</span>
                  </button>
                </div>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
